import {store} from "@/store/store";
import i18n from "@/i18n";

export default function init({next, router}) {
    if(window.location.pathname === '/result/') {
        return next();
    }

    if (store.getters['getCompanyName'] === null || store.getters['getCompanyData'] === null) {
        router.push({
            name: "error",
            params: {
                errorTitle: i18n.t("errors.COMPANY_LOADING.title"),
                errorMessage: i18n.t("errors.COMPANY_LOADING.message")
            }
        })
    }

    return next();
}
